type DataYKey = `y${number}`;

type YData = Record<DataYKey, number>;

export const getMedian = (values: number[]) => {
  values.sort(function (a, b) {
    return a - b;
  });
  const half = Math.floor(values.length / 2);
  if (values.length % 2) return values[half];
  return (values[half - 1] + values[half]) / 2.0;
};

const roundVal = (val: number, dir: "up" | "down") => {
  if (val < 1) {
    return 0;
  }
  const precision =
    dir === "down"
      ? Math.floor(Math.log10(val)) + 1
      : Math.ceil(Math.log10(val)) + 1;
  return parseFloat(val.toPrecision(precision));
};

const isNearbyNumber = (val: number, checkVal: number, threshold: number) => {
  const deviation = Math.abs(checkVal - Math.abs(val));
  return deviation < threshold;
};

const adjust = (val: number) => {
  let valAdj = val;
  if (isNearbyNumber(val, 10000, 500)) {
    valAdj = 10000;
  } else if (isNearbyNumber(val, 5000, 200)) {
    valAdj = 5000;
  } else if (isNearbyNumber(val, 1000, 100)) {
    valAdj = 1000;
  } else if (isNearbyNumber(val, 500, 50)) {
    valAdj = 500;
  } else if (isNearbyNumber(val, 250, 20)) {
    valAdj = 250;
  } else if (isNearbyNumber(val, 100, 10)) {
    valAdj = 100;
  } else if (isNearbyNumber(val, 50, 5)) {
    valAdj = 50;
  } else if (isNearbyNumber(val, 20, 2)) {
    valAdj = 20;
  } else if (isNearbyNumber(val, 10, 2)) {
    valAdj = 10;
  } else if (isNearbyNumber(val, 5, 2)) {
    valAdj = 5;
  }
  return valAdj * Math.sign(val);
};

export const getYTicks = (
  y: number[],
  // to enhance the readability of the chart the ticks will be adjusted later which can slightly increase/decrease the number of ticks.
  noTicksApprox?: number
): number[] => {
  const minY = Math.min(...y);
  const maxY = Math.max(...y);
  const rangeY = maxY - minY;
  const stepY = rangeY / (noTicksApprox ?? 5);
  const stepYTick = adjust(roundVal(stepY, "down"));
  const minYTick = adjust(roundVal(minY, "down"));
  const tickArray = [];
  let tickCounter = 0;
  do {
    tickArray.push(minYTick + tickCounter * stepYTick);
    tickCounter++;
  } while (tickArray[tickArray.length - 1] < maxY);
  return tickArray;
};



// WEBPACK FOOTER //
// ./src/components/generic/utils.ts